import {remCalc} from '../../_utils'

interface ThemeTypes {
    borderRadius: number
    colors: {
        primary: string
    }
}

export const DropdownTheme = (theme: ThemeTypes): ThemeTypes => ({
    ...theme,
    borderRadius: 0,
    colors: {...theme.colors, primary: 'black'},
})

export default {
    baseStyle: {
        '.react-select__control': {
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
            border: 'small',
            borderStyle: 'solid',
            borderRadius: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
            borderColor: 'border.secondary',
            cursor: 'pointer',
            boxShadow: 'none',
        },
        '.react-select__control--is-focused .react-select__control--menu-is-open': {
            border: 'small',
            borderStyle: 'solid',
            borderRadius: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
            borderColor: 'border.secondary',
        },
        '.react-select__option--is-selected:active': {
            backgroundColor: 'background.default',
            color: 'text.default',
        },
        '.react-select__option--is-focused': {
            backgroundColor: 'background.light',
            fontWeight: 'bold',
        },
        '.react-select__value-container--has-value': {
            px: remCalc(14),
            color: 'text.default',
        },
        '.react-select__indicator': {
            color: 'text.default',

            svg: {
                width: remCalc(24),
                height: remCalc(24),
            },
        },
        '.react-select__control--menu-is-open .react-select__indicator': {
            transform: 'rotate(180deg)',
        },
        '.react-select__menu': {
            marginTop: 0,
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.secondary',
            zIndex: 3,
            backgroundColor: 'background.default',
        },
        '.react-select__menu-list': {
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
            paddingY: 0,
        },
        '.react-select__option': {
            height: remCalc(45),
            paddingX: remCalc(10),
            paddingY: remCalc(14),
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            cursor: 'pointer',
        },
        '.react-select__single-value ': {
            textColor: 'text.default',
        },
        '.react-select__single-value--is-disabled ': {
            color: 'text.disable',
        },
        '.react-select__control--is-disabled .chakra-icon': {
            display: 'none',
        },
        '.react-select__option--is-selected': {
            backgroundColor: 'background.default',
            color: 'text.default',
        },
        '.react-select__group-heading': {
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.secondary',
            paddingTop: remCalc(4),
            paddingBottom: remCalc(10),
            paddingX: remCalc(10),
            textDecoration: 'underline',
        },
        container: {
            width: '100%',
            position: 'relative',
            _focusVisible: {
                outline: '2px solid !important',
                outlineColor: 'blue.500 !important',
                outlineOffset: '2px !important',
            },
        },
        label: {
            position: 'absolute',
            top: 0,
            left: 0,
            pointerEvents: 'none',
            transformOrigin: 'left top',
            color: 'text.secondary',
            textStyle: 'body-xxsmall',
            backgroundColor: 'background.default',
            fontWeight: 'normal',
            pr: remCalc(4),
            mx: 'xsmall.lg',
            marginTop: remCalc(-7),
            transition: 'transform 0.2s ease',
        },
        labelActive: {
            transform: `translateY(${remCalc(20)}) translateX(0)`,
            textStyle: 'body-xsmall',
        },
        errorLabel: {
            marginTop: 'xxsmall.lg',
            textStyle: 'body-xxsmall',
            fontWeight: 'normal',
            color: 'text.danger',
        },
    },
    variants: {
        invalid: {
            '.react-select__control': {
                color: 'text.disable',
                borderColor: 'border.danger',
            },
            label: {color: 'text.danger', zIndex: 1},
        },
        pdpDropdown: {
            container: {
                width: {
                    base: remCalc(168),
                    md: remCalc(351),
                    lg: remCalc(307),
                    xl: remCalc(451),
                },
            },
            '.react-select__control': {
                borderColor: 'border.secondary',
                color: 'text.default',
            },
            '.chakra-icon': {
                width: remCalc(24),
                height: remCalc(24),
            },
        },
        productRegistration: {
            '.react-select__indicator': {
                paddingX: remCalc(16),
            },
            '.chakra-icon': {
                width: remCalc(24),
                height: remCalc(24),
            },
            '.react-select__value-container': {
                px: remCalc(14),
            },
        },
        dropdownTextStyle: {
            '.react-select__menu-list': {
                textStyle: 'body-xsmall',
                fontWeight: 'normal',
                color: 'text.secondary',
                paddingY: 0,
            },
        },
        orderCancellation: {
            '.react-select__indicator': {
                color: 'text.default',
            },
            '.react-select__value-container--has-value': {
                px: remCalc(14),
            },
        },
    },
}
